import {
  differenceInMinutes,
  addDays,
  subMinutes,
  addMinutes,
  setHours,
  setMinutes,
  setSeconds,
  format,
  getDay
} from 'date-fns'
import IsOfficeOpen from './IsOfficeOpen'

export default {
  mixins: [IsOfficeOpen],
  data () {
    return {
      date: undefined,
      time: undefined
    }
  },
  computed: {
    dateOptions () {
      const currentTime = new Date()
      const noOfDates = this.openingTimes[getDay(currentTime)].nextDays

      let dates = []

      for (let i = 0; dates.length < noOfDates || i > 50; i++) {
        let thisDate = addDays(currentTime, i)

        if ((this.isBeforeStartOfDay(thisDate) || this.isOfficeOpen(thisDate)) && !this.isTooLateForSchedule(thisDate)) {
          dates.push({
            label: format(thisDate, 'EEE MMM dd yyyy'),
            label2: format(thisDate, 'EEE MMM dd'),
            label3: format(thisDate, 'EEEE do MMMM yyyy'),
            label4: format(thisDate, 'do MMMM yyyy'),
            value: thisDate
          })
        }
      }

      return dates
    },

    timeOptions () {
      if (!this.date) {
        return
      }
      const selectedDate = this.date
      const startTime = this.openingTimes[getDay(selectedDate)].start
      const endTime = this.openingTimes[getDay(selectedDate)].end

      const startOfDay = setSeconds(
        setMinutes(setHours(selectedDate, startTime[0]), startTime[1]),
        0
      )
      const endOfDay = setSeconds(
        setMinutes(setHours(selectedDate, endTime[0]), endTime[1]),
        0
      )
      const minutesPerSlot = 15
      const numOfTimeslots =
        differenceInMinutes(endOfDay, startOfDay) / minutesPerSlot

      let timeslots = []

      for (let i = 0; i < numOfTimeslots; i++) {
        let time = addMinutes(startOfDay, minutesPerSlot * i)

        timeslots.push({
          label: `${format(time, 'HH:mm')} – ${format(
            addMinutes(time, 15),
            'HH:mm'
          )}`,
          value: time
        })
      }

      timeslots = timeslots.filter((timeslot) => {
        // If office is closed, show all available timeslots
        if (!this.isOfficeOpen()) return true

        // Is more than half an hour from now
        if (timeslot.value > addMinutes(new Date(), 30)) return true

        return false
      })

      return timeslots
    }
  },
  watch: {
    date () {
      this.$nextTick(() => {
        if (this.timeOptions && this.timeOptions.length > 0) { this.time = this.timeOptions[0].value }
      })
    }
  },
  mounted () {
    this.date = this.dateOptions[0].value
  },
  methods: {
    isTooLateForSchedule (date) {
      // Last time you can schedule a same-day call, 0h 45min before closing time
      const dayNumber = getDay(new Date())
      if (dayNumber !== getDay(date)) return false
      const endTime = this.openingTimes[dayNumber].end

      const closingTime = new Date().setHours(endTime[0], endTime[1], 0, 0)
      const cutoff = subMinutes(closingTime, 0)

      return new Date() > cutoff
    }
  }
}
